<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {},
};
</script>

<style>
:root {
  --primary: #0d869c;
  --secondary: #ffa92e;
  --danger: #c1272d;
  --grey: #acb8bf;
  --grey2: #c2cbd0;
  --light: #f2f9fa;
  --light2: #f5f8fa;
  --light3: #ebf5fa;
  --dark: #595f64;
  --accent: #e2f8fe;
  --info: #daeaed;
  --border: #d6ebee;
  --highlight: #84c6d7;
  --red: #c1272d;
  --green: #39b54a;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
